/**
 * Static schema interface that marks a custom entity registry schema as an antibody-drug
 * conjugate (ADC) schema.
 * Keep in sync with benchling/schemas/schema_interfaces/v2/static_specs/static_schema_interface_specs.py
 */
export const SSI_ADC_INTERFACE_ID = 'ssi_adc';

/**
 * The ADC implemented-interface threaded through the registration insert flow.
 */
export interface ImplementedAdcSchemaInterface {
  __typename: 'ImplementedAdcSchemaInterface';
  schemaInterface: {id: typeof SSI_ADC_INTERFACE_ID};
}
